export default function () {
    document.addEventListener('DOMContentLoaded', () => {
        const $videosYoutube = document.querySelectorAll('button.ce__isnack-videoyoutube-btn-trigger');

        if (!$videosYoutube.length) {
            return;
        }

        function setYoutubeInit(element) {
            element.addEventListener('click', () => {
                // eslint-disable-next-line prefer-destructuring
                const id = element.dataset.id;
                // eslint-disable-next-line prefer-destructuring
                const source = element.dataset.source;

                // set "button wrapper div" to "none"
                const playBtn = document.querySelector('#showYouTubeModalBtn-' + id);
                playBtn.classList.add('d-none');

                // set youtube div to "block"
                playBtn.nextElementSibling.classList.add('d-block');
                // load youtube video to iframe
                playBtn.nextElementSibling.querySelector('iframe')
                    .setAttribute('src', `https://www.youtube-nocookie.com/embed/${source}?rel=0&controls=1&showinfo=1&autoplay=1`);
            });
        }

        // init ce
        $videosYoutube.forEach((videosYoutube) => {
            setYoutubeInit(videosYoutube);
        });
    });
}
